import script from "./VirtualChat.vue?vue&type=script&setup=true&lang=js"
export * from "./VirtualChat.vue?vue&type=script&setup=true&lang=js"

import "./VirtualChat.vue?vue&type=style&index=0&id=128d2f8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-128d2f8e"]])

export default __exports__